import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { IconButton } from "@mui/material";
import Card from "@mui/material/Card";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { TableContainer, Paper, Table } from "@mui/material";
import { keyframes } from "@mui/system";
import Pagination from "@mui/material/Pagination";
// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Typography from "@mui/material/Typography";
import { useParams } from "react-router-dom";
import { Switch } from "@mui/material";
 // Make sure you import this

// Authentication layout components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Encryption and Decryption Functions
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";

function CustomerDetails() {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;

  const [loading, setLoading] = useState(false);
const [openDelearModal, setOpenDelearModal] = useState(false);
const [selectedDelearId, setSelectedDelearId] = useState(null);
const [selectedDelearName, setSelectedDelearName] = useState(null);
const [currentPage, setCurrentPage] = useState(0);
const [totalPages, setTotalPages] = useState(0);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [headers, setHeaders] = useState([]);

  const [dealerDetails, setDealerDetails] = useState({
    email: "",
    role: "",
    basicprofile: {
      id: "",
      name: "",
      contact: "",
      locationid: "",
      pan: "",
      gstin: "",
      tan: "",  
      longitude:"",
      latitude:"",
    },
  });

  const [dealersList, setDealersList] = useState([]);
  const navigate = useNavigate();


    const fetchDelears = async (pageNumber = 1) => {
      setLoading(true);

      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
  
        if (!token) throw new Error("Authentication token not found.");
  
        const response = await axios.get(`/api/Customerprofile/getByAdminId/${userid}`, {
          params: { page: Math.max(0, pageNumber - 1) },    
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
        if (response.status === 200) {
          const decryptedData = decryptBody(response.data, secretKey);
          setDealersList(decryptedData.content || []);
          setCurrentPage(decryptedData.number + 1);
          setTotalPages(decryptedData.totalPages);
    
          // Get dynamic keys from first record
          const firstItem = decryptedData.content[0];
          if (firstItem) {
            const customKeys = Object.keys(firstItem.customFieldValues || {});
            const allKeys = [ ...customKeys];
            setHeaders(allKeys);
          }
        }
      } catch (error) {
        console.error("Error fetching dealers:", error);
      } finally {
        setLoading(false);
      }
    };
    

  useEffect(() => {
    fetchDelears(); 
   }, []);

 
  const handleOpenDelearModal = (DelearId,DelearName) => {
    setSelectedDelearId(DelearId);
    setSelectedDelearName(DelearName);

    setOpenDelearModal(true);
  };
  
  const handleCloseDelearModal = () => {
    setOpenDelearModal(false);
    setSelectedDelearId(null);
    setSelectedDelearName(null);

  };
  const handlePageChange = (_, pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    if (searchTerm) {
      setCurrentPage(); 
    }
  }, [searchTerm]);
  
  useEffect(() => {
    if (searchTerm) {
      searchData(currentPage); 
    } else {
      fetchDelears(currentPage);
    }
  }, [searchTerm, currentPage]);
  
  
  const searchData = async (pageNumber = 1) => {
    setLoading(true);
     
      
       console.log("Search term before API call:", searchTerm);
       try {
         setLoading(true);
         const secretKey = await fetchSecretKey();
         const token = JSON.parse(localStorage.getItem("loginData")).token;
     
         const requestBody = encryptBody({ searchTerm: searchTerm }, secretKey);
   
       const response = await axios.post(`/api/Customerprofile/search-customer-by-type`, requestBody, {
        params: { page: Math.max(0, pageNumber - 1) },      headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        console.log("Decrypted Dealer Search Response:", decryptedData); 
        setDealersList(decryptedData.content || []);
          setCurrentPage(decryptedData.number + 1);
          setTotalPages(decryptedData.totalPages);
    
      }
    } catch (error) {
      console.error("Error searching devices:", error);
    } finally {
      setLoading(false);
    }
  };
   const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  const handleOpenEditModal = async (id) => {
          setSelectedId(id);
          setOpenEditModal(true);
    };
    const handleCloseEditModal = () => {
      setOpenEditModal(false);
      setSelectedId(null);
      fetchDelears(); 
    };
    const handleOpenDeleteModal = (id) => {
      setSelectedId(id);
      setDeleteModal(true);
    };
    const handleDelete = async (e) => {
      e.preventDefault();
      setLoading(true);
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
    
        const encryptedData = encryptBody({ id: selectedId }, secretKey);
    
        const response = await axios.post(`/api/Customerprofile/delete`, encryptedData, {
          headers: { "Content-Type": "text/plain", Authorization: `Bearer ${token}` },
        });
    
        if (response.status === 200) {
          const decryptedResponse = decryptBody(response.data, secretKey);
          if (!decryptedResponse || !decryptedResponse.id) {
            throw new Error("Decryption failed or invalid response.");
          }
    
          toast.success(decryptedResponse.message || "Dealer deleted successfully!");
    
          setDeleteModal(false); 
          fetchDelears();
        }
      } catch (error) {
        toast.error(error.message || "Failed to delete Dealer.");
      } finally {
        setLoading(false);
      }
    };
    const handleToggle = async (id, currentStatus) => {
      const updatedStatus = !currentStatus;
      setDealersList((prevList) =>
        prevList.map((item) =>
          item.customerId === id
        ? {
            ...item,
              status: updatedStatus,
            
          }
        : item
    )
  );
    
      try {
        const secretKey = await fetchSecretKey();
        const token = JSON.parse(localStorage.getItem("loginData"))?.token;
        console.log("Raw data before encryption (status update):", { id, status: updatedStatus });
    
        const encryptedData = encryptBody(
          { id, status: updatedStatus },
          secretKey
        );
    
        const response = await axios.post(
          `/api/Customerprofile/update`,
          encryptedData,
          {
            headers: {
              "Content-Type": "text/plain",
              Authorization: `Bearer ${token}`,
            },
          }
        );
    
        if (response.status === 200) {
          const decryptedResponse = decryptBody(response.data, secretKey);
          if (!decryptedResponse || !decryptedResponse.id) {
            throw new Error("Decryption failed or invalid response.");
          }
    
          toast.success("Status updated successfully!");
         
        }
      } catch (error) {
        
       
    
        toast.error(error.message || "Failed to update status.");
        console.error("Toggle error:", error);
      }
    };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {loading && (
              <Box
                sx={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: "rgba(255, 255, 255, 0.8)",
                  zIndex: 9999,
                }}
              >
                <Box
                  sx={{
                    position: "relative",
                    width: 80, 
                    height: 80, 
                    animation: `${spinAnimation} 1.5s linear infinite`,
                  }}
                >
                  {dotPositions.map((pos, index) => (
                    <Box
                      key={index}
                      sx={{
                        width: 8, 
                        height: 8, 
                        borderRadius: "50%",
                                          backgroundColor: "#2e7faeff",
 
                        position: "absolute",
                        ...pos,
                      }}
                    />
                  ))}
                </Box>
              </Box>
            )}
<MDBox mt={4} p={3} display="flex" alignItems="center">
<MDTypography variant="h5">
          Customer Profiles
        </MDTypography>
        <MDBox sx={{ flex: 2, display: "flex", justifyContent: "center" }}>
        <MDInput
            label="Search  Name  Email contact"
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
              sx={{ maxWidth: "400px" }}
          />
        </MDBox>
        <MDBox sx={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>

        <MDButton variant="gradient" color="success" onClick={() => navigate("/CreateCustomers")}>
      Add Customer
    </MDButton>
      </MDBox>
      </MDBox>


      <MDBox sx={{ overflowX: "auto", width: "100%" }}>
  <TableContainer component={Paper} sx={{ mt: 3, border: "1px solid #ddd", borderRadius: "8px", boxShadow: "2px 4px 10px rgba(0,0,0,0.1)" }}>
    <Table sx={{ tableLayout: "fixed", width: "100%", borderCollapse: "collapse" }}>
      
      {/* Table Head */}
      <Grid container spacing={2}>
  {dealersList.map((dealer, index) => {
    const custom = dealer.customFieldValues || {};

    return (
<Grid item xs={12} sm={6} md={4} key={index}>
<Card
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            padding: 2,
               position: 'relative',
            height: 250,  // fixed height, adjust as needed
            minWidth: 280, // fixed width, adjust as needed
            boxSizing: 'border-box',
            cursor: 'pointer', 
            backgroundColor:  '#d0f0c0 '       ,       
            transition: 'background-color 0.3s ease, box-shadow 0.3s ease',
        
            '&:hover': {
              backgroundColor: '#e3f2fd',     
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',  
            },
          }}
          onClick={() => navigate(`/Viewcustomerdetails/${dealer.customerId}`)} 
        >         
   {/* Top-right icons */}
  <Box sx={{ position: 'absolute', top: 8, right: 8, display: 'flex', gap: 1 }}>
   
      {/* Edit Icon */}
  <IconButton
    color="default"
    onClick={(event) => {
      event.stopPropagation(); 
      navigate(`/Editcustomerdetails/${dealer.userId}`);
    }}
  >
    <EditIcon />
  </IconButton>
    <IconButton
      color="default"
      onClick={(event) => {
        event.stopPropagation();
        handleOpenDeleteModal(dealer.customerId);
      }}
    >
      <DeleteIcon />
    </IconButton>
     <Switch
      checked={!dealer.status}
      onClick={(event) => event.stopPropagation()}
      onChange={() => handleToggle(dealer.customerId, dealer.status)}
      sx={{
        '& .MuiSwitch-switchBase.Mui-checked': {
          color: '#4caf50',
        },
        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
          backgroundColor: '#4caf50',
        },
      }}
    />
  </Box>
  

    <Box sx={{ flexGrow: 1 }}>
       
   {/* Display accountBio details if available */}
   {dealer.accountBio && (
      <>
    <Typography variant="body2" sx={{ fontSize: 18, fontWeight: 400, color: 'text.primary', mt: 1  }}>
      <strong> {dealer.accountBio.name}</strong>
    </Typography>
    <Typography variant="body2" fontSize={13}>
    <strong>Customer Type:</strong> {dealer.customerType || 'Customer'}
  </Typography>
    <Typography variant="body2" sx={{ fontSize: 13, fontWeight: 400, color: 'text.primary', mt: 1  }}>
      <strong>Email:</strong> {dealer.accountBio.email}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: 13, fontWeight: 400, color: 'text.primary', mt: 1  }}>
      <strong>Contact:</strong> {dealer.accountBio.contact}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: 13, fontWeight: 400, color: 'text.primary', mt: 1  }}>
      <strong>Latitude:</strong> {dealer.accountBio.latitude}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: 13, fontWeight: 400, color: 'text.primary', mt: 1  }}>
      <strong>Longitude:</strong> {dealer.accountBio.longitude}
    </Typography>
    {/* <Typography variant="body2" sx={{ fontSize: 13, fontWeight: 400, color: 'text.primary' , mt: 1 }}>
      <strong>Address:</strong> {dealer.accountBio.address}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: 13, fontWeight: 400, color: 'text.primary', mt: 1  }}>
      <strong>City:</strong> {dealer.accountBio.city}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: 13, fontWeight: 400, color: 'text.primary', mt: 1  }}>
      <strong>State:</strong> {dealer.accountBio.state}
    </Typography>
    <Typography variant="body2" sx={{ fontSize: 13, fontWeight: 400, color: 'text.primary', mt: 1  }}>
      <strong>Pincode:</strong> {dealer.accountBio.pin}
    </Typography> */}
    {/* <Typography variant="body2" sx={{ fontSize: 13, fontWeight: 400, color: 'text.primary', mt: 1  }}>
      <strong>Country:</strong> {dealer.accountBio.country}
    </Typography> */}
   

    
 
   </>
  )}
   <Box
   sx={{
    display: 'flex',
    justifyContent: 'flex-end',
    mt: 'auto',
    pt: 1,
  }}
>
  {/* <MDButton
    color="success"
    size="small"
onClick={(event) => {
  event.stopPropagation();
  navigate(`/createinstallationaudit/${dealer.customerId}`);
}}
  >
    Installation Audit
  </MDButton> */}
</Box>

 
            {/* {Object.entries(custom).map(([key, value]) => (
              <Typography variant="body2" fontSize={13} key={key}>
                  <strong>{key}:</strong> {value}
                  </Typography>
            ))} */}
          </Box>

        
        </Card>
      </Grid>
    );
  })}
</Grid>
      <Box mt={2} display="flex" justifyContent="center">
          <Pagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            color="success"
            sx={{
              "& .MuiPaginationItem-root": {
                borderRadius: "4px", 
              },
            }}
          />
        </Box>
    </Table>
  </TableContainer>
</MDBox>

     
      {/* {openEditModal && (
            <EditDealer
              isOpen={openEditModal}
              onRequestClose={handleCloseEditModal}
              id={selectedId}
            />
          )} */}
          
      <Modal open={deleteModal} onClose={() => setDeleteModal(false)} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
        <Card sx={{ padding: 3, width: "400px", textAlign: "center" }}>
          <Typography variant="h6" gutterBottom>Are you sure you want to delete this  Customer Details?</Typography>
          <MDButton onClick={handleDelete} color="error"  sx={{ minWidth: "60px", marginRight: "5px", padding: "5px 10px" }}>Yes</MDButton>&emsp;
          <MDButton color="secondary" onClick={() => setDeleteModal(false)} sx={{ minWidth: "30px" }}>Cancel</MDButton>
        </Card>
      </Modal>

     
    </DashboardLayout>
  );
}

export default CustomerDetails;

